import { useEffect } from 'react';
import _throttle from 'lodash/throttle';

type ScrollData = { scrollY: number; trackLength: number };

function getScrollData(element: HTMLElement): ScrollData {
  const winHeight = element?.clientHeight;
  const scrollHt = element?.scrollHeight;
  const trackLength = scrollHt - winHeight;
  const scrollY = element?.scrollTop;
  return { scrollY: Number.isNaN(scrollY) ? 0 : scrollY, trackLength: Number.isNaN(trackLength) ? 0 : trackLength };
}

const throttledOnScroll = _throttle(
  ({
    disabled,
    scrollEl,
    onScroll,
  }: {
    disabled: boolean;
    scrollEl: HTMLElement;
    onScroll: ({ scrollY, trackLength }: ScrollData) => void;
  }) => {
    if (!disabled) {
      const scrollData = getScrollData(scrollEl);
      onScroll?.(scrollData);
    }
  },
  100
);

type Props = {
  onScroll: ({ scrollY, trackLength }: ScrollData) => void;
  disabled: boolean;
  scrollEl: HTMLElement;
};

export const useScrollWatch = ({ onScroll, scrollEl, disabled }: Props): void => {
  useEffect(() => {
    const newCalcScroll = () => throttledOnScroll({ disabled, scrollEl, onScroll });

    scrollEl?.addEventListener('scroll', newCalcScroll);
    return () => {
      scrollEl?.removeEventListener('scroll', newCalcScroll);
    };
  }, [onScroll, scrollEl, disabled]);
};
